import React, { useContext, useEffect, useState } from 'react'
import { FormRow } from '../../../../../_components/Forms/FormRow'
import { Box } from '../../../../../components/Box/Box'
import { S_ScheduleEsigningContacts } from './DebtorsContacts/DebtorsContacts.styles'
import { Grid, GridCol } from '../../../../../components/Grid'
import { getUsersForBusiness } from '../../../../../_services/lender.service'
import ScheduleESigningContext from './context'

export const ClientContacts = ({ businessId, businessName, templateName }) => {
  const [clientContacts, setClientContacts] = useState([])
  const { addSigner, signers } = useContext(ScheduleESigningContext)
  useEffect(() => {
    getUsersForBusiness(businessId).then((resp) => setClientContacts(resp))
  }, [businessId, templateName])

  const key = `client_contact`
  const role = 'Business'

  const selectedOption = () => {
    const signer = Object.entries(signers).find(([_key, value]) => {
      return value.role === 'Business'
    })

    if (signer) {
      return signer[0]
    }

    return ''
  }

  return (
    <Box>
      <S_ScheduleEsigningContacts>
        <Grid columns={2}>
          <GridCol xs={1.5}>
            <FormRow
              className={''}
              defaultValue={selectedOption()}
              id={key}
              label={businessName}
              layout={'inline'}
              onChange={(id) => {
                const contact = clientContacts.find((contact) => +contact.id === +id)
                addSigner(contact.id, { ...contact, id: businessId }, role)
              }}
              options={clientContacts.map((contact) => {
                return {
                  display: `${contact?.first_name || ''} ${contact?.last_name || ''} (${contact.email_address})`,
                  value: contact.id,
                }
              })}
              placeholder={'Select Contact'}
              type={'select'}
            />
          </GridCol>
        </Grid>
      </S_ScheduleEsigningContacts>
    </Box>
  )
}
